import { styled } from "styled-components";
import CharacterAction from "./CharacterAction";
import Button from "./Button";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  @media (max-width: 800px) {
    display: ${(props) => (props.tab === "actions" ? `flex` : `none`)};
  }
`;

const Mobiled20 = styled.div`
  display: none;
  @media (max-width: 800px) {
    display: block;
  }
`;

const CharacterActions = ({ character, rollDie, currentTab }) => {
  return (
    <Wrapper tab={currentTab}>
      <Mobiled20>
        <Button onClick={() => rollDie("", 0)}>Roll a d20</Button>
      </Mobiled20>
      {character.actions.map((action, index) => (
        <CharacterAction
          key={index}
          character={character}
          action={action}
          onClick={() => rollDie(action.name, character.bonuses[action.stat])}
        />
      ))}
    </Wrapper>
  );
};

export default CharacterActions;
